import { openQuickshop } from '../helpers';

/**
 * Listens for external scripts to open the quickshop modal via a custom event.
 *
 * Dispatch from any script on the page:
 *   document.dispatchEvent(
 *     new CustomEvent('quickshop:open', {
 *       detail: { productUrl: '/products/my-handle' },
 *     })
 *   );
 *
 * @param {string} detail.productUrl - Shopify product path (e.g. /products/handle)
 */
export default function initQuickshop() {
  document.addEventListener('quickshop:open', event => {
    const { productUrl } = event.detail ?? {};
    if (productUrl) {
      openQuickshop(productUrl);
    }
  });
}
